import axios from "axios";

export function createAccounts(data) {
  let configAccount = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/line-accounts`,
    data: data
  };

  return axios(configAccount);
}

export function createBusinesses(data) {
  let configBusiness = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/line-accounts/${data.accountId}/businesses`,
    data: data
  };
  return axios(configBusiness);
}

export function createRichmenu(accountId ,data) {
  let configBusiness = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/line-accounts/${accountId}/richmenu`,
    data: data
  };
  return axios(configBusiness);
}

export function createDefaultItem(accountId) {
  let configBusiness = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/line-accounts/${accountId}/default-item`,
    data: {}
  };
  return axios(configBusiness);
}

export function insertQrcode(data, type, shopId, webVersion) {
  const url = `${process.env.VUE_APP_APIHOST}/${type}/shops/${shopId}/qrcode${webVersion ? `/${webVersion}` : ''}`;
  var config = {
    method: "post",
    url,
    data
  };
  return axios(config);
}


export function updateCode(accountId, type) {
  let configBusiness = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${accountId}/code`,
    data: {}
  };
  return axios(configBusiness);
}

export function toShortUrl(url) {
  let configBusiness = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/apis/shorturl`,
    data: {url}
  };
  return axios(configBusiness);
}

export function updateLineOa(data, type) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${data.accountId}/update-oa`,
    data: {data}
  };
  return axios(config);
}

export function delRichmenu(data, type) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${data.accountId}/del-richmenu`,
    data: {data}
  };
  return axios(config);
}

export function postLineSpot(data, si) {
  data.si = si;
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/apis/line-spot`,
    data: {data}
  };
  return axios(config);
}


export function createOrderLimit(type, accountId, data) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/${type}/accounts/${accountId}/order-limit`,
    data: data
  };
  return axios(config);
}

export function createPrinterTemplate(d) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/printer-template`,
    data: d
  };
  return axios(config);
}

export function createLogisticOrder(orderId) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/orders/${orderId}/logistic-recall`,
    data: {}
  };
  return axios(config);
}

export function excelUpload(data) {
  let config = {
    method: "post",
    headers: { "Content-Type": "multipart/form-data" },
    url: `${process.env.VUE_APP_EXCEL_TO_JSON_API}/excel-upload`,
    data
  };
  return axios(config);
}

export function saveOaSettings(data) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${data.accountId}/oa_settings`,
    data: {}
  };
  return axios(config);
}

export function createPromotion(data, type) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${data.businessId}/promotions`,
    data: data
  };
  return axios(config);
}

export function promotionSetting(data, type) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${data.businessId}/promotions/${data.id}/setting`,
    data: {data}
  };
  return axios(config);
}


export function createScanner(accountId, data, type) {
  let config = {
    method: 'POST',
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${accountId}/scanners`,
    data
  }
  return axios(config);
}

export function editAcls(data, type) {
  let accountId = data.accountId;
  let configAccount = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/${type}/${type}-shops/${accountId}/acls`,
    data: data
  };

  return axios(configAccount);
}